import axios from 'axios';
import { apiCube, AuthorizationCube } from '../utils/index';

const prefix = 'BENEFICIARIES';

export const GET_START = `${prefix}_GET_START`;
export const GET_SUCCESS = `${prefix}_GET_SUCCESS`;
export const GET_ERROR = `${prefix}_GET_ERROR`;

function getBeneficiariesStart() {
  return {
    type: GET_START
  };
}

function getBeneficiariesSuccess(data) {
  return {
    type: GET_SUCCESS,
    payload: {
      data
    }
  };
}

function getBeneficiariesError(error) {
  return {
    type: GET_ERROR,
    payload: {
      error
    }
  };
}

export function getBeneficiaries() {
  if (AuthorizationCube)
    axios.defaults.headers.common.Authorization = AuthorizationCube;

  const query = encodeURI(
    JSON.stringify({
      measures: ['BeneficiaryDemographicTags.count'],
      dimensions: [
        'BeneficiaryDemographicTags.name',
        'BeneficiaryDemographicTags.id'
      ],
      filters: [
        {
          dimension: 'BeneficiaryDemographicTags.enabled',
          operator: 'equals',
          values: ['1']
        }
      ]
    })
  );

  return dispatch => {
    dispatch(getBeneficiariesStart());
    return axios
      .get(`${apiCube}cubejs-api/v1/load?query=${query}`)
      .then(response => response.data)
      .then(data => dispatch(getBeneficiariesSuccess(data)))
      .catch(error => dispatch(getBeneficiariesError(error)));
  };
}
